<template>
  <div
    v-if="
      $localStorageService.can('DX_14_ver_paciente') ||
      $localStorageService.can('DX_13_ver_paciente') ||
      $localStorageService.can('DX_12_ver_paciente') ||
      $localStorageService.can('DX_10_ver_paciente')
    "
  >
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div v-b-popover.hover.auto=mensaje>
      <b-button variant="outline-info" class="nombreBoton" @click="siguenteFlujo(data.item.idSolicitudEtapa, data.item)" >
        Presentar
      </b-button>
    </div>

  </div>
</template>

<script>
import {MotorService} from "@/apiServices/motor/MotorService";

export default {
  name: "BandejaLinkPresentarReplicaComponente",
  props: {
    data: Object,
    resource: Object,
  },
  data() {
    return {
      motorServicio : new MotorService(),
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
    }
  },
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    siguenteFlujo(idSolicitudEtapa,item) {

      if (item.estatus === 'Finalizado'){
        this.$swal.fire({
          icon: "info",
          text: "Etapa finalizada",
        });
        return false;
      }

//presentacionPtiReplica
      const params = {
        idSolicitudEtapa: idSolicitudEtapa,
        objeto: null
      }

      this.motorServicio
          .obtenerSiguenteFlujo(params).then((respuesta) => {
            let url = respuesta.data.urlPantalla;
            if (respuesta.data.parametros.length > 0) {
              url = url + "/"+item.idPti+'/'+item.idSolicitudEtapa+'/';
              respuesta.data.parametros.forEach((p, i) => {
                url = url + p.valor;
                if (i + 1 < respuesta.data.parametros.length) {
                  url = url + "/";
                }
              });
              url = url + "/" + respuesta.data.idEtapa;
            }
            this.$router.push(url);
          }).finally(() => {
            this.loader = false;
            this.funcionExtraBandeja(1);
          });
    },

    funcionExtraBandeja(data) {
      this.$emit("_funcionExtra", data);
    },
  },
};
</script>
